export class Coupon {
    public static STATE = {
        ACTIVE: 'COUPON_STATE_ACTIVE',
        VALID: 'COUPON_STATE_VALID',
        ASSIGNED: 'COUPON_STATE_ASSIGNED',
        WITHDRAWN: 'COUPON_STATE_WITHDRAWN'
    };
}
